import $ from 'jquery';
import APIV5 from '~/models/api';
import Utils from '~/scripts/services/utils';
import template from './k-file-upload.html';
import templateModalKfileTree from './modal/modal-kfile-tree.html';
import ModalKfileTreeController from './modal/modal-kfile-tree.controller';

/** @type {import('@knitiv/api-client-javascript').FormGetForm['params']['file']['upload']} */
const defaultParameters = {
	blacklist: [],
	camera:    true,
	html:      true,
	local:     true,
	tree:      false,
	whitelist: ['*'],
};

const kFileUploadDirective = /* @ngInject */ (
	/** @type {import('angular').ICompileService} */ $compile,
	/** @type {import('angular').ITimeoutService} */ $timeout,
	/** @type {import('angular').translate.ITranslateService} */ $translate,
	/** @type {import('angular').ui.bootstrap.IModalService} */ $uibModal,
	/** @type {any} */ Notification,
) => ({
	restrict: 'A',
	scope:    {
		fileUpload: '&kFileUpload',
		multiple:   '=?kFileMultiple',
		params:     '=?kFileParams',
	},
	link:     (/** @type {any} */ scope, /** @type {any} */ element) => {
		scope.id = `ng-upload-btn-${Utils.s4()}-${Utils.s4()}`;
		scope.params = {
			...defaultParameters,
			...scope.params,
		};

		scope.accept = scope.params.whitelist ? scope.params.whitelist.join(',') : '*';

		scope.upload = (/** @type {File[]} */ files) => {
			if (scope.multiple) {
				scope.fileUpload({ $files: files });
				scope.files = files;
			}
			else if (Array.isArray(files)) {
				scope.fileUpload({ $file: files[0] });
				[scope.files] = files;
			}
			else {
				scope.fileUpload({ $file: files });
				scope.files = files;
			}
		};

		if ($(`#${scope.id}`).length === 0) {
			element.after($compile(template)(scope));
		}

		element.bind('click', async (/** @type {MouseEvent} */ event) => {
			event.preventDefault();
			if (scope.params.tree) {
				element.attr('disabled', true);
				const tree = await APIV5.instance.kFileTreeGet({ tree_kid: null }, { id: 'k-file-upload.link' });
				element.attr('disabled', false);

				if (tree.items.length > 0) {
					const files = await $uibModal.open({
						template:     templateModalKfileTree,
						controller:   ModalKfileTreeController,
						controllerAs: '$ctrl',
						windowClass:  'modal-kfile-tree',
						resolve:      {
							local:    () => scope.params.local,
							multiple: () => scope.multiple,
							items:    () => tree.items,
						},
					}).result;
					scope.upload(files);
				}
				else if (scope.params.local) {
					$(`#${scope.id}`).trigger('click');
				}
				else {
					Notification.error({
						title:   $translate.instant('error.unable-to-process'),
						message: $translate.instant('error.file-filesystem-empty'),
					});
				}
			}
			else if (scope.params.local) {
				$(`#${scope.id}`).trigger('click');
			}
		});
	},
});

export default kFileUploadDirective;
